import { useQuery } from '@tanstack/react-query';
import { contactDtoSchema, type ContactDto } from '@tg-hookah/shared/dto';
import { api } from '@/lib/api';

export function useContacts() {
  return useQuery({
    queryKey: ['contacts'],
    queryFn: async (): Promise<ContactDto> => {
      const res = await api.get('/contacts');
      return contactDtoSchema.parse(res.data);
    },
  });
}
